<ng-container
	*ngIf="{
		buttonDisabled: buttonDisabled | async,
		filteredCountries: filteredCountries$ | async,
		prefixText: prefixText | async,
		showVatError: showVatError | async,
		userData: data,
	} as viewData"
>
	<div class="sf-dialog-header">
		<h4 class="sf">
			{{
				'sf.shared_component.my_account.user_data.' +
					(viewData.userData.dataType === userDataType.InvoiceData ? 'billing' : 'buyer') | translate
			}}
		</h4>
		<mat-icon [mat-dialog-close]="true" class="close-icon">close</mat-icon>
	</div>
	<mat-dialog-content [formGroup]="userDetailsForm">
		<div class="form-wrapper">
			<sf-error-box
				*ngIf="viewData.showVatError"
				label="sf.shared_component.my_account.user_data.user_data_form.vat_verification"
			></sf-error-box>
			<div class="radio-container">
				<mat-radio-group
					(change)="customerTypeChange($event)"
					[formControlName]="userDataFormControls.CustomerType"
					aria-label="Select an option"
					(click)="resolvePreviousData()"
				>
					<mat-radio-button [value]="customerType.INDIVIDUAL">{{
						'sf.common.customer_type.individual' | translate
					}}</mat-radio-button>
					<mat-radio-button [value]="customerType.COMPANY">{{
						'sf.common.customer_type.company' | translate
					}}</mat-radio-button>
				</mat-radio-group>
			</div>

			<div *ngIf="!isCompanySelected" class="form-row">
				<div class="field-wrapper">
					<sf-input
						class="top"
						[requiredAsterisk]="true"
						[formControlName]="userDataFormControls.FirstName"
						[label]="'sf.shared_component.my_account.user_data.user_data_form.first_name' | translate"
						[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.first_name' | translate"
					>
					</sf-input>
				</div>
				<div class="field-wrapper">
					<sf-input
						class="top"
						[requiredAsterisk]="true"
						[formControlName]="userDataFormControls.LastName"
						[label]="'sf.shared_component.my_account.user_data.user_data_form.last_name' | translate"
						[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.last_name' | translate"
					>
					</sf-input>
				</div>
			</div>

			<div *ngIf="isCompanySelected" class="field-wrapper">
				<sf-input
					class="top"
					[requiredAsterisk]="true"
					[formControlName]="userDataFormControls.Company"
					[label]="'sf.shared_component.my_account.user_data.user_data_form.company' | translate"
					[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.company' | translate"
				>
				</sf-input>
			</div>

			<div class="form-row">
				<div class="field-wrapper">
					<sf-input
						class="top"
						[requiredAsterisk]="true"
						[formControlName]="userDataFormControls.Address"
						[label]="'sf.shared_component.my_account.user_data.user_data_form.address' | translate"
						[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.address' | translate"
					>
					</sf-input>
				</div>
				<div class="field-wrapper">
					<sf-input
						class="top"
						[requiredAsterisk]="true"
						[formControlName]="userDataFormControls.City"
						[label]="'sf.shared_component.my_account.user_data.user_data_form.city' | translate"
						[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.city' | translate"
					>
					</sf-input>
				</div>
			</div>

			<div class="form-row">
				<div class="field-wrapper">
					<sf-input
						class="top"
						[requiredAsterisk]="true"
						[formControlName]="userDataFormControls.PostCode"
						[label]="'sf.shared_component.my_account.user_data.user_data_form.post_code' | translate"
						[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.post_code' | translate"
					>
					</sf-input>
				</div>
				<div class="field-wrapper">
					<sf-input
						type="number"
						class="top"
						[formatIntegers]="true"
						[requiredAsterisk]="true"
						[prefixAsField]="!!viewData.prefixText"
						[prefixText]="viewData.prefixText"
						[formControlName]="userDataFormControls.Phone"
						[label]="'sf.shared_component.my_account.user_data.user_data_form.phone' | translate"
						[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.phone' | translate"
					>
					</sf-input>
				</div>
			</div>

			<div class="field-wrapper">
				<sf-country-selector
					[formControlName]="userDataFormControls.CountryCode"
					[label]="'sf.shared_component.my_account.user_data.user_data_form.country' | translate"
				></sf-country-selector>
			</div>

			<div *ngIf="isCompanySelected" class="field-wrapper">
				<sf-input
					type="text"
					class="top"
					[requiredAsterisk]="true"
					[formControlName]="userDataFormControls.VatNumber"
					[label]="'sf.shared_component.my_account.user_data.user_data_form.vat_number' | translate"
					[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.vat_number' | translate"
					[labelInfoTooltip]="
						countryControl.value !== 'PL'
							? 'sf.module.license.invoice_details.customer_details.vat_prefix'
							: 'sf.shared_component.my_account.user_data.user_data_form.vat_number_tooltip'
					"
				>
				</sf-input>
			</div>
			<div *ngIf="!isCompanySelected" class="field-wrapper">
				<sf-input
					type="text"
					class="top"
					[requiredAsterisk]="true"
					[formControlName]="userDataFormControls.PersonalIdNumber"
					[label]="'sf.shared_component.my_account.user_data.user_data_form.personal_id' | translate"
					[placeholder]="'sf.shared_component.my_account.user_data.user_data_form.personal_id' | translate"
				>
				</sf-input>
			</div>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="onSaveClick()"
			mat-flat-button
			color="accent"
			[disabled]="userDetailsForm.invalid || viewData.buttonDisabled"
		>
			{{ 'sf.common.save' | translate | uppercase }}
		</button>
		<button mat-flat-button color="primary" [mat-dialog-close]="true">
			{{ 'sf.module.rations.my_rations.general.cancel' | translate | uppercase }}
		</button>
	</mat-dialog-actions>
</ng-container>
